// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://assets.shmedia.tech/css/swiper.min.css);"]);
// Module
exports.push([module.id, ".panel{background:#fff}.swiper-slide-active img{transition:all 3s;transform:scale(1.2)}", ""]);
// Exports
module.exports = exports;
